import isEqual from 'lodash/isEqual';

import { StrokeCharacterData } from '../../../../models/FileStore';

// import {
//   DEFAULT_DIRECTION_TOLERANCE,
//   DEFAULT_DISTANCE_TOLERANCE,
//   DEFAULT_LENGTH_TOLERANCE,
// } from '../../../../../game/components/finger-writing/finger-writing-game-config';
// import { equals } from '../../../../utils/geometry';
// import { toleranceToLeniency } from '../../../../utils/stroke';
import { FontStroke } from './FontStroke';

// const stripDuplicates = (points) => {
//   if (points.length < 2) {
//     return points;
//   }

//   const result = points.reduce(
//     (acc, cur) => {
//       if (!acc.lastPoint || !equals(acc.lastPoint, cur)) {
//         acc.points.push(cur);
//         acc.lastPoint = cur;
//       }
//       return acc;
//     },
//     { lastPoint: undefined, points: [] },
//   );

//   return result.points;
// };

export class Character {
  locale: string;
  character: string;
  strokes: FontStroke[];

  constructor({
    locale,
    character,
    strokes,
    medians,
    componentPaths,
  }: StrokeCharacterData) {
    this.locale = locale;
    this.character = character;

    let currentComponent: number | undefined;
    let currentComponentPath: number[] | null | undefined;
    this.strokes = strokes.map((stroke, i) => {
      if (currentComponent === undefined) {
        currentComponent = 0;
        currentComponentPath = componentPaths[i];
      } else if (!isEqual(currentComponentPath, componentPaths[i])) {
        currentComponent = currentComponent + 1;
        currentComponentPath = componentPaths[i];
      }
      return new FontStroke(
        stroke,
        medians[i] as [number, number][] | [number, number][][],
        currentComponent,
      );
    });
  }

  getComponentStart(component: number): number {
    let index = this.strokes.findIndex((s) => s.component === component);
    if (index === -1) {
      index = this.strokes.length;
    }
    return index;
  }

  // for convenience, use matching logic from hanzi-writer instead of cocos2d-app for now
  // https://github.com/chanind/hanzi-writer/blob/master/src/strokeMatches.ts
  // match(index, userStroke, strokeSettings = {}) {
  //   const points = stripDuplicates(userStroke);
  //   const {
  //     showHint,
  //     distanceTolerance = DEFAULT_DISTANCE_TOLERANCE,
  //     lengthTolerance = DEFAULT_LENGTH_TOLERANCE,
  //     directionTolerance = DEFAULT_DIRECTION_TOLERANCE,
  //   } = strokeSettings ?? {};

  //   const distanceLeniency = toleranceToLeniency(
  //     distanceTolerance,
  //     index,
  //     showHint ? 5 : 0,
  //   );
  //   const lengthLeniency = toleranceToLeniency(
  //     lengthTolerance,
  //     index,
  //     showHint ? 5 : 0,
  //   );
  //   const shapeLeniency = toleranceToLeniency(
  //     directionTolerance,
  //     index,
  //     showHint ? 3 : 0,
  //   );

  //   if (points.length < 2) {
  //     return null;
  //   }

  //   const { isMatch, avgDist } = this.strokes[index]?.getMatchData(points, {
  //     distanceLeniency,
  //     lengthLeniency,
  //     shapeLeniency,
  //     showHint,
  //   }) ?? { isMatch: false };

  //   if (!isMatch) {
  //     return false;
  //   }

  //   // if there is a better match among strokes the user hasn't drawn yet, the user probably drew the wrong stroke
  //   const closestMatchDist = this.strokes
  //     .slice(index + 1)
  //     .reduce((acc, cur) => {
  //       const result = cur.getMatchData(points, {
  //         distanceLeniency,
  //         lengthLeniency,
  //         shapeLeniency,
  //         showHint,
  //       });
  //       return result.isMatch && result.avgDist < acc ? result.avgDist : acc;
  //     }, avgDist);

  //   // if there's a better match, rather that returning false automatically, try reducing leniency instead
  //   // if leniency is already really high we can allow some similar strokes to pass
  //   if (closestMatchDist < avgDist) {
  //     // adjust leniency between 0.3 and 0.6 depending on how much of a better match the new match is
  //     const leniencyAdjustment =
  //       (0.6 * (closestMatchDist + avgDist)) / (2 * avgDist);
  //     return this.strokes[index].getMatchData(points, {
  //       distanceLeniency: (distanceLeniency || 1) * leniencyAdjustment,
  //       lengthLeniency: (lengthLeniency || 1) * leniencyAdjustment,
  //       shapeLeniency: (shapeLeniency || 1) * leniencyAdjustment,
  //       showHint,
  //     }).isMatch;
  //   }

  //   return true;
  // }
}
